module.exports = __webpack_public_path__ + "static/media/homepage_product.40feb423.svg";